import { RavenButton, RavenToggleSlide } from '@ravenpay/raven-bank-ui';
import React, { useEffect, useState } from 'react';
import './style/styles.css';

import { brands, icons } from '../../../assets/icons';
import {
	IconVault,
	formatDateTime,
	formatNumWithComma,
	symbol,
} from '../../../utils/helper/Helper';
import glo from '.../../../assets/images/glo.png';
import airtel from '../../../assets/images/airtel.png';
import mobile from '../../../assets/images/9mobile.png';
import mtn from '../../../assets/images/mtn.png';
import { logger } from '../../../services/logger';
interface PreviewDetails {
	onBtnClick?: (event?: any) => any;
	multi?: boolean;
	content?: any;
	loading?: boolean;
	img?: string;
}

const PreviewDetailsBox = ({
	content,
	multi,
	img,
	loading,
	onBtnClick,
}: PreviewDetails) => {
	const [currentItem, setCurrentItem] = useState<any>({});
	const [currentItemIndex, setCurrentItemIndex] = useState(0);

	useEffect(() => {
		if (multi) {
			setCurrentItem(content[currentItemIndex]);
		} else {
			setCurrentItem(content);
		}
	}, [multi ? currentItemIndex : '']);

	function handleNext() {
		if (currentItemIndex === content.length - 1) {
			setCurrentItemIndex(0);
		} else {
			setCurrentItemIndex(currentItemIndex + 1);
		}
	}

	function handlePrev() {
		if (currentItemIndex === 0) {
			setCurrentItemIndex(content.length - 1);
		} else {
			setCurrentItemIndex(currentItemIndex - 1);
		}
	}

	return (
		<div className="preview-payment-view">
			<div className="preview-payment-view__logo">
				{content[currentItemIndex]?.provider?.name.toLowerCase() === 'glo' ||
				content[currentItemIndex]?.provider?.name.toLowerCase() === 'mtn' ||
				content[currentItemIndex]?.provider?.name.toLowerCase() === 'airtel' ||
				content[currentItemIndex]?.provider?.name.toLowerCase() ===
					'9mobile' ? (
					<figure className="logo">
						{<img src={content[currentItemIndex]?.provider?.icon} alt="" />}
						{icons.arrow_rounded_green_right}
					</figure>
				) : (
					<figure className="logo">
						{<img src={content?.provider?.icon} alt="" />}
					</figure>
				)}
			</div>

			<div className="preview-payment-view-main">
				<div className="preview-payment-view__header">
					<h5>
						<p>{currentItem?.amount}</p>
					</h5>
					<small>{formatDateTime(new Date())}</small>
				</div>

				{multi && (
					<div className="preview-payment-view__switch">
						<figure onClick={handlePrev} className="pages__current">
							{icons.chevron_right}
						</figure>
						<div className="switch__pages">
							<p>{currentItemIndex + 1}/</p>
							<p>{content.length}</p>
						</div>
						<figure onClick={handleNext} className="pages__total">
							{icons.chevron_right}
						</figure>
					</div>
				)}

				<div className="preview-payment-view__table">
					<div className="table__item">
						<p>Mobile Number</p>
						<p>0{currentItem?.phone}</p>
					</div>
					<div className="table__item">
						<p>Network Provider</p>
						<p>{currentItem?.provider?.name?.toUpperCase()}</p>
					</div>

					<div className="table__item">
						<p>Amount</p>
						<p>{currentItem?.amount}</p>
					</div>

					<div className="table__item">
						<p>Fee</p>
						<p>Free 😎</p>
					</div>
				</div>
			</div>
		</div>
	);
};

export default PreviewDetailsBox;
